import React, { PureComponent } from 'react'
import Hls from 'hls.js'
import { message } from 'antd'
import DOM from 'react-dom'
import Plyr from 'plyr'
import './index.scss'
import 'plyr/dist/plyr.css'

interface Props {
  type?: 'm3u8' | 'audio' | 'video' | ''
  src: string
  onplay: () => any
}

class VPlayer extends PureComponent<Props> {
  static defaultProps = {
    type: 'video',
  }

  player: Plyr

  componentDidUpdate(prevProps) {
    const { src, type } = this.props
    return prevProps.src !== src ? this.init(type, src) : null
  }

  componentDidMount() {
    const { type, src } = this.props
    this.init(type, src)
  }

  componentWillUnmount() {
    return this.player.destroy()
  }

  init(type, src) {
    const dom = DOM.findDOMNode(this) as HTMLVideoElement
    this.player = new Plyr(dom, {
      controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'settings',
        'airplay',
        'fullscreen',
      ],
      i18n: {
        speed: '速度',
        normal: '正常',
      },
      invertTime: false,
      keyboard: {
        focused: true,
      },
    })

    type === 'm3u8' || /\.m3u8$/.test(src)
      ? this.usingHls(dom, src)
      : (dom.src = src)

    this.player.on('error', () => {
      if (typeof this.props.src === 'string' && this.props.src === '') {
        message.error('播放源可能已损坏，请联系管理员')
      }
    })

    this.player.on('playing', () => this.props.onplay && this.props.onplay())
  }

  usingHls(dom, src) {
    if (!Hls.isSupported()) {
      throw new Error("this browser can't support hls.")
    }
    const hls = new Hls()
    hls.loadSource(src)
    return hls.attachMedia(dom)
  }

  render() {
    return this.props.type === 'audio' ? (
      <audio className="plyr" />
    ) : (
      <video className="plyr" />
    )
  }
}

export default VPlayer
